import {AIControlMainApp} from './app/ai-control/AIControlMainApp.js';
window.AIControlMainApp = AIControlMainApp;

import {AIControlOledApp} from './app/ai-control/AIControlOledApp.js';
window.AIControlOledApp = AIControlOledApp;

import {AIControlLedApp} from './app/ai-control/AIControlLedApp.js';
window.AIControlLedApp = AIControlLedApp;

import {CBMSMainApp} from './app/cbms/CBMSMainApp.js';
window.CBMSMainApp = CBMSMainApp;

import {CBMSTabletApp} from './app/cbms/CBMSTabletApp.js';
window.CBMSTabletApp = CBMSTabletApp;
